import { PageRef } from 'providers/page-ref';

export type AdvancedTrainingMethodsPageParams = {};

export const IAdvancedTrainingMethodsPage: PageRef<AdvancedTrainingMethodsPageParams, void> = {
  pageName: 'AdvancedTrainingMethodsPage',
} as PageRef<AdvancedTrainingMethodsPageParams, void>;
